module.exports = __webpack_public_path__ + "media/images/icons/filled/dropbox-square-dcdc44f34df929bc36e3d8ef30a11658.svg";